<template>
    <v-card id="form_card">
        <v-card-title>
            <v-icon left>mdi-cogs</v-icon>
                <span class="subtitle-1 font-weight-regular application--card--title">Število parkirnih mest (rezervacija)</span>
                <v-spacer></v-spacer>
            <v-btn icon @click="toggleCardContent('card1')">
                <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider v-show="card1"></v-divider>

        
        <v-card-text v-show="card1">
            <!--<p class="body-2 font-weight-regular card--text"><v-icon class="p--icon" medium color="secondary" left>mdi-information</v-icon>{{ settingsTimeRestrictionText }}</p>-->
            <v-alert
            border="right"
            colored-border
            color="secondary"
            elevation="1"
            icon="mdi-information"
            >
            {{ settingsTimeRestrictionText }}
            </v-alert>
            <v-container grid-list-xl text-x-center align-center>
                <v-form id="form_parking_spaces" ref="form" v-model="valid" lazy-validation>
                    <v-layout row justify-center v-bind="columnBinding" id="form_card">
                        <v-flex xs12 md4 align-content-center>
                            <v-subheader class="pt-5 pl-0"><strong>Vnesite število parkirnih mest</strong></v-subheader>
                        </v-flex>
                        <v-flex xs12 md8 align-content-center>
                            <v-text-field
                                v-model="parking_spaces"
                                label="Vnesite število vseh parkirnih mest."
                                append-icon="mdi-pencil"
                                clearable
                                type="number"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-container>
        </v-card-text>
        <v-divider v-if="card1"></v-divider>
        <v-card-actions v-if="card1">
            <!-- shrani prekliči -->
            <v-btn @click="saveSettings()" color="success" text :disabled="loading" :loading="loading"><v-icon left>mdi-arrow-right</v-icon>Shrani</v-btn>
                <v-btn @click="cancelSettings()" color="error" :disabled="loading" text><v-icon left>mdi-close</v-icon>Prekliči</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
    name: 'parking-spaces',
    data: () => ({
        valid: true,
        settingsTimeRestrictionText: "V spodnje polje vnesite število vseh parkirnih mest.",
        card1: true,
        card2: true,
        loading: false,
        parking_spaces: null, 
        current_value: null,
        dialog:false,
        interval: null,

        parking_spaces_rules: [v => !!v || 'Polje za vnos števila parkirnih mest je obvezno'],
    }),

    watch: {

    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },
    },

    methods: {
        toggleCardContent(card) {
            if(card === 'card1') {
                this.card1 = !this.card1
            }
        },

        fetchSettingsData() {
            var vm = this
            vm.dialog = false
            vm.$store.commit('SET_PROGRESS', true)
            vm.$store.dispatch('GET_SETTINGS')
            .then(response => {
                //window.console.log(response)
                response.data.forEach(item => {
                    if(Object.prototype.hasOwnProperty.call(item, 'key')) {
                        if(item.key == 'parking_spaces') {
                            vm.parking_spaces = item.value
                        }
                    }
                })
            })
            .catch(error => {
                window.console.log("GET_SETTINGS")
                window.console.log(error)
            })
            .finally(()=> {
                setTimeout(() => {
                    vm.$store.commit('SET_PROGRESS', false)
                }, 700)
            }) 
        },

        saveSettings() {
            var vm = this
            vm.loading = true
            vm.dialog = false
            vm.$store.commit('SET_PROGRESS', true)
            vm.$store.dispatch('SAVE_SETTINGS', {
                parking_spaces: vm.parking_spaces
            })
            .then(response => {
                //window.console.log(response)
                vm.$store.commit('SET_SNACKBAR_DISPLAY', false)
                vm.$store.commit('SET_SNACKBAR_TEXT', "Nastavitve so bile uspešno posodobljene.")
                vm.$store.commit('SET_SNACKBAR_MODE', 'multi-line')
                vm.$store.commit('SET_SNACKBAR_TIMEOUT', 7000)
                vm.$store.commit('SET_SNACKBAR_DISPLAY', true)
                vm.parking_spaces = response.parking_spaces
                vm.fetchSettingsData()
            })
            .catch(error => {
                window.console.log("SAVE_SETTINGS")
                window.console.log(error)
                vm.$store.commit('SET_SNACKBAR_DISPLAY', false)
                vm.$store.commit('SET_SNACKBAR_TEXT', "Pri shranjevanju nastavitev je prišlo do napake. Poskusite ponovno.")
                vm.$store.commit('SET_SNACKBAR_MODE', 'multi-line')
                vm.$store.commit('SET_SNACKBAR_TIMEOUT', 7000)
                vm.$store.commit('SET_SNACKBAR_DISPLAY', true)
            })
            .finally(()=> {
                setTimeout(() => {
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.loading = false
                }, 700)
            })
            
        },

        cancelSettings() {
            this.parking_spaces = null;
            this.$refs.form.resetValidation();
            this.fetchSettingsData()
        },
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
    },

    mounted() {
        var vm = this
        this.fetchSettingsData();

        vm.interval = setInterval(() =>{
            vm.fetchSettingsData
        }, 30000);
    },

    destroyed() {
        clearInterval(this.interval)
    }
}

</script>

<style scoped>

</style>